.day {
  margin: 16px 4px 6px;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--muted-dim);
}

.day:first-of-type {
  margin-top: 0;
}

.entry {
  display: grid;
  grid-template-columns: 48px 34px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 10px 12px;
  border-radius: 16px;
  background: transparent;
  box-shadow: none;
  color: var(--text);
  text-align: left;
  font-weight: 400;
}

.entry:hover,
.entry[aria-expanded='true'] {
  background: var(--pill-bg);
}

.entry[aria-expanded='true'] {
  box-shadow: inset 0 0 0 1px var(--line);
}

.time {
  font-size: 13px;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

.who {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid var(--line);
  color: var(--accent);
  font-family: var(--font-display);
}

.whoAdmin {
  color: var(--text);
  background: var(--pill-bg);
}

.text {
  min-width: 0;
}

.text b {
  font-weight: 500;
}

.sub {
  display: block;
  font-size: 13px;
  color: var(--muted);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.badges {
  display: flex;
  gap: 6px;
}

.badges :global(.badge) {
  margin-right: 0;
}

.changed {
  background: color-mix(in srgb, var(--accent) 16%, transparent);
  color: var(--accent);
}

.warn {
  background: color-mix(in srgb, var(--warn) 16%, transparent);
  color: var(--warn);
}

.details {
  display: grid;
  gap: 12px;
  margin: 4px 0 10px 94px;
  padding: 16px 18px;
  border: 1px solid var(--line);
  border-radius: 18px;
  background: var(--bg-raised);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  font-size: 13px;
  color: var(--muted);
}

.meta b {
  color: var(--text);
  font-weight: 400;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
}

.ua {
  overflow-wrap: anywhere;
}

.diff {
  display: grid;
  border: 1px solid var(--line);
  border-radius: 14px;
  overflow: hidden;
  font-size: 14px;
}

.diffHead,
.diffRow {
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr) minmax(0, 1fr);
}

.diffHead span,
.diffRow span {
  padding: 9px 12px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.diffHead {
  background: var(--pill-bg);
  font-size: 11px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--muted-dim);
}

.diffRow {
  border-top: 1px solid var(--line);
}

.field {
  color: var(--muted);
}

.from {
  color: var(--muted);
  text-decoration: line-through;
  text-decoration-color: color-mix(in srgb, var(--danger) 60%, transparent);
}

.err4,
.err5 {
  display: grid;
  gap: 4px;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 14px;
}

.err4 {
  border: 1px solid color-mix(in srgb, var(--warn) 50%, transparent);
  background: color-mix(in srgb, var(--warn) 8%, transparent);
}

.err5 {
  border: 1px solid color-mix(in srgb, var(--danger) 45%, transparent);
  background: color-mix(in srgb, var(--danger) 8%, transparent);
}

.err4 b,
.err5 b {
  font-weight: 500;
}

@media (max-width: 640px) {
  .entry {
    grid-template-columns: 34px minmax(0, 1fr);
    padding: 10px 8px;
  }

  .time {
    display: none;
  }

  .badges {
    grid-column: 2;
  }

  .details {
    margin-left: 0;
    padding: 14px;
  }

  .diffHead {
    display: none;
  }

  .diffRow {
    grid-template-columns: minmax(0, 1fr);
  }

  .diffRow .field {
    padding-bottom: 0;
    font-size: 12px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  .diffRow .from::before {
    content: 'было: ';
  }

  .diffRow .to::before {
    content: 'стало: ';
    color: var(--muted-dim);
  }
}
